import { z } from 'zod';
export const FORUM_ACTIVITY_KINDS = {
    ThreadCreated: 'forum.thread.created',
    ThreadUpdated: 'forum.thread.updated',
    ThreadDeleted: 'forum.thread.deleted',
    ThreadLocked: 'forum.thread.locked',
    ThreadHidden: 'forum.thread.hidden',
    ThreadMoved: 'forum.thread.moved',
    PostCreated: 'forum.post.created',
    PostUpdated: 'forum.post.updated',
    PostAccepted: 'forum.post.accepted',
    VoteCast: 'forum.vote.cast',
    Subscribed: 'forum.thread.subscribed',
    Unsubscribed: 'forum.thread.unsubscribed',
};
export const FORUM_ACTIVITY_KIND_GLOB = 'forum.*';
const Iso = z.string().datetime({ offset: true });
export const ForumThreadEvent = z.object({
    type: z.string(),
    threadId: z.string().uuid(),
    groupId: z.string().uuid(),
    actorId: z.string().uuid(),
    occurredAt: Iso,
});
export const ForumPostEvent = z.object({
    type: z.string(),
    threadId: z.string().uuid(),
    postId: z.string().uuid(),
    parentId: z.string().uuid().nullable(),
    authorId: z.string().uuid(),
    mentions: z.array(z.string().uuid()),
    occurredAt: Iso,
});
export const ForumPostAcceptedEvent = z.object({
    type: z.literal('forum.post.accepted'),
    threadId: z.string().uuid(),
    postId: z.string().uuid(),
    acceptedBy: z.string().uuid(),
    authorId: z.string().uuid().nullable(),
    occurredAt: Iso,
});
//# sourceMappingURL=events.js.map